module.exports = __webpack_public_path__ + "static/wild_geranium_20x19-c04538ad4816cb3b0ce73bdf4e0da8bf.jpg";